import { render } from "./HeroiconsOutlineShoppingBag.vue?vue&type=template&id=65b3cf67"
const script = {}

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineShoppingBag.vue"]])

export default __exports__